paddingDirectiveModule = angular.module('padding.setting', [])

paddingDirectiveModule.directive "paddingSetting", ["$window", "$timeout", "$compile", "$templateCache", ($window, $timeout, $compile, $templateCache) ->
  restrict: "A",
  scope: {data: "=ngModel", afterChange: '&'},
  templateUrl: "#{settingFolder}/padding/template.jade"
  link: (scope, element, attrs, ngModel) ->

    # Установка отступа в 10px при изменении модели mobilePadding для сохранения обратной совместимости
    if !scope.data and attrs.ngModel is "widget.style_attributes.mobilePadding"
      scope.data = "10px 10px 10px 10px"
    else if !scope.data
      scope.data = "0px 0px 0px 0px"

    paddingSplit = scope.data.split " "

    scope.padding = {
      top: parseInt paddingSplit[0]
      right: parseInt paddingSplit[1]
      bottom: parseInt paddingSplit[2]
      left: parseInt paddingSplit[3]
    }

    listener = scope.$watchCollection "padding", (newVal) ->
      scope.data = "#{newVal.top}px #{newVal.right}px #{newVal.bottom}px #{newVal.left}px"

    scope.$on "$destroy", ->
      listener()

]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/padding/padding.directive.coffee